module.exports = __webpack_public_path__ + "img/foto-productos.5ecb32e3.jpg";